import { useMemo } from "react";
import useSWR from "swr";

import type { FederationContextResponse } from "src/types/federation";
import { endpoints, fetcher } from "src/utils/axios";


export function useGetFederationContext(
  providerId?: number | null,
  sport?: string | null,
) {
  const normalizedSport =
    sport === null || sport === undefined
      ? null
      : sport.trim().toLowerCase();
  const url =
    providerId && providerId > 0
      ? endpoints.provider.federation.context(providerId)
      : null;
  const key =
    url && normalizedSport !== null
      ? [url, { params: { sport: normalizedSport } }]
      : url;
  const { data, error, isLoading, isValidating, mutate } =
    useSWR<FederationContextResponse>(key, fetcher, {
      keepPreviousData: false,
    });

  return useMemo(
    () => ({
      federationContext: data,
      federationContextLoading: Boolean(url) && isLoading,
      federationContextValidating: Boolean(url) && isValidating,
      federationContextError: error,
      mutateFederationContext: mutate,
    }),
    [data, error, isLoading, isValidating, mutate, url],
  );
}
